export default {
  'dept.title': '區域名稱',
  'dept.btn.add': '新增區域',
  'dept.btn.addSubsidiary': '新增子區域',
  'dept.btn.edit': '編輯區域',
  'dept.btn.del': '刪除區域',
  'dept.input.dept.placeholder': '請輸入區域名稱',
};
